import { Suspense, lazy } from 'react';
import { Navigate, RouteObject, redirect} from 'react-router-dom';
// import { RouteObject } from 'react-router';

import SidebarLayout from './layouts/SidebarLayout';
import BaseLayout from './layouts/BaseLayout';

import SuspenseLoader from './components/SuspenseLoader';
import AuthProvider from './provider/authProvider';
import { ProtectedRoute } from './routes/ProtectedRoute';

const Loader = (Component) => (props) =>

  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Login = Loader(lazy(() => import('./content/login')));

const QC = Loader(lazy(() => import('./content/applications/qc')));
const OrdersQc = Loader(lazy(() => import('./content/applications/orders-qc/OrdersQc')));

const Messenger = Loader(lazy(() => import('./content/applications/Messenger')));

const Building = Loader(lazy(() => import('./content/pages/Building')));

const SubtitleDownload = Loader(lazy(() => import('./content/pages/Encoding')));

const BatonCopy = Loader(lazy(() => import('./content/pages/BatonCopy')));

const UserManagement = Loader(lazy(() => import('./content/applications/Admin/UserManagement')));
const Home = Loader(lazy(() => import('./content/pages/Home')));
const Quiz = Loader(lazy(() => import('./content/pages/Quiz')));
const ArchiveRetrieval = Loader(lazy(() => import('./content/pages/ArchiveRetrieval')));
const Wrapped = Loader(lazy(() => import('./content/pages/Wrapped')));

const Systems = Loader(lazy(() => import('./content/applications/Admin/Systems')));
const EncodeProfiles = Loader(lazy(() => import('./content/applications/Admin/EncodeProfiles')));
const MuxConfig = Loader(lazy(() => import('./content/applications/Admin/MuxConfig')));
const FontingRules = Loader(lazy(() => import('./content/applications/Admin/FontingRules')));
const ShelfDefinitions = Loader(lazy(() => import('./content/applications/Admin/ShelfDefinitions')));
const Jobs = Loader(lazy(() => import('./content/applications/Admin/Jobs')));
const AdminJobsReport = Loader(lazy(() => import('./content/applications/Admin/AdminJobsReport')));
const Languages = Loader(lazy(() => import('./content/applications/Admin/Languages')));
const LanguageDictionaries = Loader(lazy(() => import('./content/applications/Admin/LanguageDictionaries'))); 
const AdminOrdersReport = Loader(lazy(() => import('./content/applications/Admin/AdminOrdersReport')));
const OrderDashboard = Loader(lazy(() => import('./content/applications/Admin/OrderDashboard')));

const Orders = Loader(
  lazy(() => import('./content/applications/orders'))
);

// Throwaway dev harness — not linked in the sidebar; navigate to /matcher-eval.
const MatcherEval = Loader(
  lazy(() => import('./content/applications/orders/matcher-eval/MatcherEval'))
);

const StatusComingSoon = Loader(
  lazy(() => import('./content/pages/Status/ComingSoon'))
);

const UserSettings = Loader(
  lazy(() => import('./content/applications/Users/settings'))
);

const CatalogModule = Loader(lazy(() => import('./content/applications/Catalog')));
const CatalogOrderList = Loader(lazy(() => import('./content/applications/Catalog/views/OrderList')));
const TitleOrders = Loader(lazy(() => import('./content/applications/TitleOrders')));
const TitleAssets = Loader(lazy(() => import('./content/applications/TitleAssets')));

const QcReview = Loader(lazy(() => import('./content/applications/qc-review')));

const routes: RouteObject[] = [

  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/login',
        element: <Login />
      },
      {
        path: 'login',
        element: <Navigate to="/login" replace />
      }
    ]//login children
  },//login
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/pages/wrapped',
        element: <Wrapped />
      },
      {
        path: 'wrapped',
        element: <Navigate to="/pages/wrapped" replace />
      }
    ]//login children
  },//login
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/qc" replace />
        },
        {
          path: 'qc',
          element: <QC />
        }

      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        {
          path: 'orders-qc',
          element: <OrdersQc />
        }
      ]
    }]
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/orders" replace />
        },
        {
          path: 'orders',
          element: <Orders />
        }

      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'matcher-eval',
      element: <BaseLayout />,
      children: [
        {
          path: '',
          element: <MatcherEval />
        }
      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/systems" replace />
        },
        {
          path: 'systems',
          element: <Systems />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/jobs" replace />
        },
        {
          path: 'jobs',
          element: <Jobs />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/encodeProfiles" replace />
        },
        {
          path: 'encodeProfiles',
          element: <EncodeProfiles />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/muxConfig" replace />
        },
        {
          path: 'muxConfig',
          element: <MuxConfig />
        }

      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/fontingRules" replace />
        },
        {
          path: 'fontingRules',
          element: <FontingRules />
        },
        {
          path: 'shelfDefinitions',
          element: <ShelfDefinitions />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/languages" replace />
        },
        {
          path: 'languages',
          element: <Languages />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/LanguageDictionaries" replace />
        },
        {
          path: 'languageDictionaries',
          element: <LanguageDictionaries />
        }

      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/admin/users" replace />
        },
        {
          path: 'users',
          element: <UserManagement />
        }
      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'admin',
      element: <SidebarLayout />,
      children: [
        {
          path: 'orderDashboard',
          element: <OrderDashboard />
        }
      ]
    },
  ]},
  {
    path: '/',
    element: <ProtectedRoute />,
    children:
    [{
      path: 'admin',
      element: <BaseLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/adminJobsReport" replace />
        },
        {
          path: 'adminJobsReport',
          element: <AdminJobsReport />
        }

      ]
    },
  ]},
  ,
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'admin',
      element: <BaseLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/adminOrdersReport" replace />
        },
        {
          path: 'adminOrdersReport',
          element: <AdminOrdersReport />
        }

      ]
    },
  ]},
  { 
    path: '/',
    element: <ProtectedRoute />,
    children: 
    [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/Messenger" replace />
        },
        {
          path: 'Messenger',
          element: <Messenger />
        }

      ]
    },
  ]},
    { 
      path: '/',
      element: <ProtectedRoute />,
      children: 
      [{
        path: 'pages',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/encoding" replace />
          },
          {
            path: 'encoding',
            element: <SubtitleDownload />
          }
  
        ]
      },
    ]},
    { 
      path: '/',
      element: <ProtectedRoute />,
      children: 
      [{
        path: 'pages',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/batonCopy" replace />
          },
          {
            path: 'batonCopy',
            element: <BatonCopy />
          }
  
        ]
      },
    ]},{ 
      path: '/',
      element: <ProtectedRoute />,
      children: 
      [{
        path: 'pages',
        element: <BaseLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/quiz" replace />
          },
          {
            path: 'quiz',
            element: <Quiz />
          }
  
        ]
      },
    ]},
    { 
      path: '/',
      element: <ProtectedRoute />,
      children: 
      [{
        path: 'pages',
        element: <BaseLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/home" replace />
          },
          {
            path: 'home',
            element: <Home />
          }
  
        ]
      },
    ]},
    {
      path: '/',
      element: <ProtectedRoute />,
      children: [{
        path: 'pages',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/ArchiveRetrieval" replace />
          },
          {
            path: 'ArchiveRetrieval',
            element: <ArchiveRetrieval />
          }
        ]
      }]
    },
    { 
      path: '/',
      element: <ProtectedRoute />,
      children: 
      [{
        path: 'pages',
        element: <SidebarLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/building" replace />
          },
          {
            path: 'building',
            element: <Building />
          }
  
        ]
      },
    ]},
    
  // {
  //   path: 'status',
  //   element: <SidebarLayout />,
  //   children: [
  //     {
  //       path: '',
  //       element: <Navigate to="/coming-soon" replace />
  //     },
  //     {
  //       path: 'coming-soon',
  //       element: <StatusComingSoon />
  //     }
  //   ]
  // },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [{
      path: 'management',
      element: <SidebarLayout />,
      children: [
        {
          path: 'profile/settings',
          element: <UserSettings />
        }
      ]
    }]
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        { path: 'catalog', element: <CatalogModule /> },
        { path: 'catalog/browse', element: <Navigate to="/applications/catalog?view=browse" replace /> },
        { path: 'catalog/orders', element: <CatalogOrderList /> },
        { path: 'title-orders', element: <TitleOrders /> },
        { path: 'title-assets', element: <TitleAssets /> },
      ]
    }]
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [{
      path: 'applications',
      element: <SidebarLayout />,
      children: [
        { path: 'qc-review', element: <QcReview /> },
      ]
    }]
  },
  {
    path: '/',
    element: <Navigate to="/login" replace />
  },
  {
    path:'*',
    element:<Navigate to="/login" replace />
  }


]

// const routes: RouteObject[] = [
//   {
//     path: '',
//     element: <BaseLayout />,
//     children: [
//       {
//         path: '/',
//         element: <Overview />
//       },
//       {
//         path: 'overview',
//         element: <Navigate to="/" replace />
//       },
//       {
//         path: 'status',
//         children: [
//           {
//             path: '',
//             element: <Navigate to="404" replace />
//           },
//           {
//             path: '404',
//             element: <Status404 />
//           },
//           {
//             path: '500',
//             element: <Status500 />
//           },
//           {
//             path: 'maintenance',
//             element: <StatusMaintenance />
//           },
//           {
//             path: 'coming-soon',
//             element: <StatusComingSoon />
//           }
//         ]
//       },
//       {
//         path: '*',
//         element: <Status404 />
//       }
//     ]
//   },
//   {
//     path: 'dashboards',
//     element: <SidebarLayout />,
//     children: [
//       {
//         path: '',
//         element: <Navigate to="crypto" replace />
//       },
//       {
//         path: 'crypto',
//         element: <Crypto />
//       },
//       {
//         path: 'messenger',
//         element: <Messenger />
//       }
//     ]
//   },
//   {
//     path: 'management',
//     element: <SidebarLayout />,
//     children: [
//       {
//         path: '',
//         element: <Navigate to="transactions" replace />
//       },
//       {
//         path: 'transactions',
//         element: <Transactions />
//       },
//       {
//         path: 'profile',
//         children: [
//           {
//             path: '',
//             element: <Navigate to="details" replace />
//           },
//           {
//             path: 'details',
//             element: <UserProfile />
//           },
//           {
//             path: 'settings',
//             element: <UserSettings />
//           }
//         ]
//       }
//     ]
//   },
//   {
//     path: '/components',
//     element: <SidebarLayout />,
//     children: [
//       {
//         path: '',
//         element: <Navigate to="buttons" replace />
//       },
//       {
//         path: 'buttons',
//         element: <Buttons />
//       },
//       {
//         path: 'modals',
//         element: <Modals />
//       },
//       {
//         path: 'accordions',
//         element: <Accordions />
//       },
//       {
//         path: 'tabs',
//         element: <Tabs />
//       },
//       {
//         path: 'badges',
//         element: <Badges />
//       },
//       {
//         path: 'tooltips',
//         element: <Tooltips />
//       },
//       {
//         path: 'avatars',
//         element: <Avatars />
//       },
//       {
//         path: 'cards',
//         element: <Cards />
//       },
//       {
//         path: 'forms',
//         element: <Forms />
//       }
//     ]
//   }
// ];

export default routes;
